var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "#D38FCD",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0385 38.2809C28.1483 38.3914 28.327 38.3917 28.4372 38.2816L39.6655 27.0532C40.3036 26.4151 40.2974 25.3787 39.6517 24.7483C39.0168 24.1286 38.0017 24.1348 37.3744 24.7621L28.4031 33.7333L24.0438 29.374C23.3718 28.702 22.2823 28.702 21.6104 29.374C20.9401 30.0443 20.9382 31.1305 21.6061 31.8032L28.0385 38.2809ZM30.6667 53.1667C25.5139 51.8785 21.2812 48.888 17.9688 44.1953C14.6562 39.5026 13 34.359 13 28.7646V15.625L30.6667 9L48.3333 15.625V28.7646C48.3333 34.359 46.6771 39.5026 43.3646 44.1953C40.0521 48.888 35.8194 51.8785 30.6667 53.1667ZM30.6667 49.7438C34.8993 48.3451 38.3498 45.7043 41.0182 41.8214C43.6866 37.9384 45.0208 33.5861 45.0208 28.7646V17.9438L30.6667 12.5333L16.3125 17.9438V28.7646C16.3125 33.5861 17.6467 37.9384 20.3151 41.8214C22.9835 45.7043 26.434 48.3451 30.6667 49.7438Z",
    fill: "#0226A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.0639f12e3aeac9c913688ef2ff305d40.svg";
export { ForwardRef as ReactComponent };